<template>


    <div class="c-exam">

        <div class="einfo">
            <div class="einfo-l">考试名称：</div>
            <div class="einfo-r">{{examMsg.examName}}</div>
        </div>

        <div class="einfo">
            <div class="einfo-l">考试时间：</div>
            <div class="einfo-r">{{examMsg.time}}</div>
        </div>

        <div class="einfo" v-if="examMsg.score === 0 || examMsg.score  ">
            <div class="einfo-l">满分：</div>
            <div class="einfo-r">{{examMsg.score}}</div>
        </div>

        <div class="einfo" v-if="examMsg.myScore === 0 || examMsg.myScore  ">
            <div class="einfo-l">得分：</div>
            <div class="einfo-r">{{examMsg.myScore}}</div>
        </div>

        <div class="etips">
            本次考试共{{examMsg.count}}科，点击查看详情获取成绩等级位置、各科分数与相关错题等信息
        </div>

        <div class="ebtn" @click="bind()" v-track="{ name: 'checkScore_detail'}">查看详情</div>
    </div>




</template>

<script>


    export default {
        name: 'examCard',
        data(){
            return {
                detail:{}
            }
        },
        props: {
            examMsg:{
                type:Object
            }
        },
        methods:{
            bind(){
                this.$router.push('/download');
            }
        },
        computed:{


        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    .c-exam{
        box-shadow:0px 0px 10px 0px rgba(3,0,1,0.1) !important;
        padding: 16px;
        border-radius:10px;
        margin-top: 15px;
        margin-bottom: 25px;
    }

    .einfo{
        display: flex;
        align-items:center;
        justify-content: space-around;
        font-size: 16px;
        margin-top: 6px;
        margin-bottom: 6px;
        .einfo-l{
            flex-grow: 1;
            flex: 0 0 85px;
            text-align: right;

            color: #adadad;
        }
        .einfo-r{
            flex-grow: 1;
            flex: 1;
            margin-top: 1px;
        }
    }

    .etips{
        color:#ed5b68 ;
        font-size: 14px;
        margin-top: 10px;
    }

    .ebtn{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100px;
        height: 26px;
        font-size: 14px;
        color:#ed5b68;
        border: 1px solid #ed5b68;
        border-radius: 13px;
        margin-top: 15px;
        margin-left: calc(50% - 50px);

    }

</style>
